<template>
  <div class="app-page">
    <div class="application-page-header">
      <div class="navigation-panel" @click="$router.push('/group/list')">
        <left-outlined />
        <a-button type="link">{{ $t('user.Back') }}</a-button>
      </div>
      <div class="page-title">{{ $t('user.' + $route.meta.title) }}</div>
    </div>
    <div class="application-page-container">
      <div class="application-info-list" style="font-size: 16px; padding-top: 16px">
        <div class="application-info-item">
          <div class="info-title">{{ $t('user.Name') }}:</div>
          <div class="info-text">{{ employeeName }}</div>
        </div>
        <div class="application-info-item">
          <div class="info-title">{{ $t('user.Current Brand') }}:</div>
          <div class="info-text">{{ employeeBrand }}</div>
        </div>
        <div class="application-info-item">
          <div class="info-title">{{ $t('user.Review Manager') }}:</div>
          <div class="info-text">{{ employeeLineManager }}</div>
        </div>
        <div class="application-info-item">
          <div class="info-title">{{ $t('user.Application Season') }}:</div>
          <div class="info-text">{{ season }}</div>
        </div>
      </div>

      <div class="application-info-list" v-if="!isOfflineMode">
        <div class="application-info-item">
          <div class="info-title">{{ $t('user.Current Role') }}:</div>
          <div class="info-text">{{ currentRole }}</div>
        </div>
      </div>
      <div class="application-info-list" v-if="!isOfflineMode">
        <div class="application-info-item">
          <div class="info-title">{{ $t('user.Target Role') }}:</div>
          <div class="info-text">{{ targetRole }}</div>
        </div>
      </div>

      <div class="application-info-table" v-if="panelResult.result">
        <a-table
          class="panel-result-table"
          :columns="[
            {
              title: 'Panel Result',
              key: 'result',
              width: '30%',
              dataIndex: 'result',
            },
            {
              title: 'Panel Comments',
              key: 'comments',
              dataIndex: 'comments',
            },
          ]"
          :data-source="[panelResult]"
          :pagination="false"
        >
          <template v-slot:emptyText>
            <Empty />
          </template>
          <template #headerCell="{ title }">
            {{ $t('user.' + title) }}
          </template>
        </a-table>
      </div>
      <div class="application-info-list" style="font-weight: initial !important; font-size: 12px; padding-bottom: 16px" v-if="!isOfflineMode">*{{ $t('user.The highlighted items show the key difference between this level and one level down.') }}</div>
      <div class="application-info" v-if="!isOfflineMode">
        <div class="application-info-left">
          <ApplyTable class="record-table" :hideTips="true" v-model:data="applicationRecord" :status="0" />
          <div class="btn-submit-group">
            <a-button class="btn-save" type="primary" @click="$router.back()">
              {{ $t('user.Back') }}
            </a-button>
          </div>
        </div>
        <div class="application-info-right">
          <div class="application-info-right-list">
            <div class="application-info-right-list-top">
              <div class="application-info-header">
                <div class="application-info-title question-circle">
                  <span>{{ $t('user.Learning') }}</span>
                  <!-- <a-tooltip>
                <template #title>
                  <span style="color: green">&check;</span>
                  and
                  <span style="color: red">&cross;</span>
                  are marked based on the valid record of training attendance.
                  If the mandatory courses are not completed due to speical
                  reason, talents have left comments here.
                </template>
                <QuestionCircleFilled :style="{ fontSize: '14px' }" />
              </a-tooltip> -->
                </div>
              </div>
              <div class="application-info-sub-header">
                <div class="application-info-title">
                  {{ $t('user.Mandatory') }}
                </div>
              </div>
              <div v-for="(doc, index) in docs" :key="index" class="application-info-content">
                <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
                <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
                <div :class="{ 'doc-highlight': doc.type == 'doc_highlight' }">
                  {{ doc.f }}
                </div>
              </div>
              <!-- <div
              :class="`jinfo-content ${
                jobInfo.resources == null ? 'default' : 'list'
              }`"
              v-html="
                jobInfo.resources ||
                'Please select role to see learning resources.'
              "
            ></div> -->
              <div class="application-info-sub-header" v-if="docs_optional.length > 0">
                <div class="application-info-title">
                  {{ $t('user.Optional') }}
                </div>
              </div>
              <div v-for="(doc, index) in docs_optional" :key="index" class="application-info-content">
                <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
                <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
                <div :class="{ 'doc-highlight': doc.type == 'doc_highlight' }">
                  {{ doc.f }}
                </div>
              </div>
            </div>
            <div class="application-info-right-list-bottom">
              <div class="application-info-footer">
                <div class="application-info-comment">
                  <label class="application-info-title">
                    {{ $t('user.Employee') }}
                  </label>
                  <div class="application-info-comment-detail">
                    <div class="jinfo-content comments">
                      <a-popover v-model:visible="commentsViewPopoverVisible" v-if="comment != '' && comment != null" placement="bottom">
                        <template #content>
                          <div class="comments-view-popover">
                            <div class="comments-view-text">{{ comment }}</div>
                          </div>
                        </template>
                        <a-button type="link">
                          <svg-icon color="#ac7f40" icon-class="search-view"></svg-icon>
                          <span>&nbsp;{{ $t('user.View Comments') }}</span>
                        </a-button>
                      </a-popover>
                      <span v-else>{{ $t('user.No Comments') }}</span>
                    </div>
                  </div>
                </div>
                <div class="application-info-comment">
                  <label class="application-info-title">
                    {{ $t('user.Review Manager') }}
                  </label>
                  <div class="application-info-comment-detail">
                    <div class="jinfo-content comments">
                      <a-popover v-model:visible="commentsLMViewPopoverVisible" v-if="lm_comment != '' && lm_comment != null" placement="bottom">
                        <template #content>
                          <div class="comments-view-popover">
                            <div class="comments-view-text">
                              {{ lm_comment }}
                            </div>
                          </div>
                        </template>
                        <a-button type="link">
                          <svg-icon color="#ac7f40" icon-class="search-view"></svg-icon>
                          <span>&nbsp;{{ $t('user.View Comments') }}</span>
                        </a-button>
                      </a-popover>
                      <span v-else>{{ $t('user.No Comments') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 线下模式的返回按钮 -->
      <div class="btn-groups no-padding" v-if="isOfflineMode">
        <a-button class="btn-back-bottom" type="primary" @click="$router.back()">
          {{ $t('user.Back') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Modal, message } from 'ant-design-vue'
  import { getGroupApplicationDetail, saveApplication, approveApplication, disapproveApplication } from '@/api/index'
  import ApplyTable from '@/components/ApplyTable'
  import { mapActions, mapGetters } from 'vuex'
  import {
    LeftOutlined,
    CheckOutlined,
    CloseOutlined,
    // QuestionCircleFilled,
  } from '@ant-design/icons-vue'
  import Empty from '@/components/Empty'

  export default {
    name: 'Index',
    components: {
      CheckOutlined,
      CloseOutlined,
      LeftOutlined,
      // QuestionCircleFilled,
      ApplyTable,
      Empty,
    },
    data() {
      return {
        currentRole: null,
        targetRole: null,
        currentRoleTheme: null,
        targetRoleTheme: null,
        employeeName: null,
        employeeBrand: null,
        employeeLineManager: null,
        result: null,
        applicationRecord: [],
        // status: 0,
        commentsViewPopoverVisible: false,
        commentsLMViewPopoverVisible: false,
        panelResult: {},
        comment: '',
        lm_comment: '',
        current_guide: { records: {} },
        season: null,
      }
    },
    computed: {
      ...mapGetters({
        offlineMode: 'user/offlineMode',
      }),
      isOfflineMode() {
        return this.offlineMode
      },
      docs() {
        const records = this.current_guide.records
        if (records) {
          return (
            this.current_guide.docs
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.current_guide.docs
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
      docs_optional() {
        const records = this.current_guide.records
        if (records) {
          return (
            this.current_guide.docs_optional
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.current_guide.docs_optional
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
    },
    mounted() {
      const aId = this.$route.params.id
      if (aId) {
        getGroupApplicationDetail(aId).then((res) => {
          if (res.code == 200) {
            const { current, target } = res.data
            this.currentRole = current
            this.currentRoleTheme = res.data.current_theme
            this.targetRole = target
            this.targetRoleTheme = res.data.target_theme
            this.employeeName = res.data.name
            this.employeeLineManager = res.data.lm_name
            this.employeeBrand = res.data.current_brand
            this.current_guide = res.data.current_guide
            this.comment = res.data.comment
            this.lm_comment = res.data.lm_comment
            this.season = res.data.season
            // this.result = res.data.result
            if (res.data.PanelResult) {
              this.panelResult = {
                result: res.data.PanelResult,
                comments: res.data.PanelComments,
              }
              this.$store.commit('routes/setSider', 'group/details/2')
            }

            const tableData = {}
            res.data.items.forEach((item) => {
              tableData[item.key] = {
                id: item.key,
                content: item.value,
                style: item.style,
              }
            })
            res.data.self_comments.forEach((item, index) => {
              if (tableData[index] != null) {
                tableData[index].e_qualified = item.check
                tableData[index].e_comments = item.comments
              }
            })
            res.data.lm_comments.forEach((item, index) => {
              if (tableData[index] != null) {
                tableData[index].t_qualified = item.check
                tableData[index].t_comments = item.comments
              }
            })
            this.applicationRecord = Object.keys(tableData).map((key) => {
              return { ...tableData[key] }
            })

            console.log(this.applicationRecord)
          }
        })
      }
    },
    methods: {},
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');
  .appliction-page-success {
    height: 495px;
    padding-top: 68px;
    background-color: white;
    margin: 16px;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    .msg-icon {
      width: 72px;
      height: 72px;
      color: #43a047;
    }
    .btn-group-success {
      margin-top: 60px;
      display: flex;
      justify-content: center;
      .btn-view,
      .btn-back {
        margin: 0 8px;
      }
    }
  }
  .application-page-header {
    background-color: white;
    padding: 8px 32px;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    .page-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }
    .navigation-panel {
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      .ant-btn,
      .anticon {
        font-size: 14px;
        color: #333333;
      }
    }
  }
  .application-page-container {
    margin: @app-conetent-margin;
    // background-color: white;
    padding-top: 8px;
  }
  .application-info-table {
    background-color: #fff;
    padding: 8px 24px;
  }
  .application-info-list {
    background-color: #fff;
    padding: 8px 24px;
    display: flex;
    text-align: left;
    font-size: 14px;
    color: #333333;
    line-height: 22px;

    .application-info-item {
      display: flex;
      flex: 1;
      // min-width: 33%;
      // min-width: 500px;
    }
    .info-title {
      font-weight: bold;
      margin-right: 12px;
    }
    .info-text {
      font-size: 14px;
      font-family: Helvetica;
      color: #333333;
      line-height: 22px;
    }
  }
  .record-table {
    padding: 16px 24px;
  }

  .btn-submit-group {
    padding: 24px;
    .btn-save {
      width: 90px;
      margin: 0 8px;
    }
    .btn-next {
      width: 90px;
      margin: 0 8px;
    }
  }

  .btn-groups {
    padding: 18px 24px 24px 24px;
    .ant-btn {
      margin-right: 16px;
    }
    &.no-padding {
      padding: 0;
      padding-top: 16px;
    }
  }
  .popover-tips {
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    .anticon {
      color: #faba16;
    }
  }

  .application-info {
    display: flex;
    margin-top: @app-conetent-margin;

    &-left {
      background-color: white;
      flex-grow: 7;
      width: 70%;
      margin-right: 16px;
    }

    &-right {
      background-color: white;
      border: 1px solid #e9e9e9;
      // margin-top: 16px;
      // margin-right: 24px;
      // margin-bottom: 16px;
      flex-grow: 3;
      width: 30%;
      position: relative;

      &-list {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    &-header {
      padding: 16px 24px;
      border-bottom: 1px solid #e9e9e9;
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }
    &-title {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-weight: 700;

      &.question-circle {
        display: flex;
        align-items: center;
        span {
          margin-right: 2px;
        }
      }
    }

    &-sub-header {
      padding: 16px 24px;
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }

    &-content {
      padding: 0px 24px;
      padding-bottom: 14px;
      white-space: pre-line;
      display: flex;
      &.list {
        padding: 16px 24px;
      }
      &.default {
        padding: 14px 24px;
      }
      div {
        padding-left: 8px;
        position: relative;
        top: -2px;
      }

      .doc-highlight {
        color: @primary-color;
      }
    }

    &-comment {
      display: flex;
      align-items: center;
      padding: 0px 24px 16px 24px;
    }

    &-footer {
      // position: absolute;
      padding-bottom: 16px;
      // bottom: 0;

      label {
        &::after {
          content: ':';
          margin: 0 8px 0 2px;
          position: relative;
          top: -0.5px;
        }
      }
    }
  }
  .panel-result-table td {
    word-break: break-word;
  }
</style>
